var render = function render(){var _vm=this,_c=_vm._self._c;return _c('h1',{staticClass:"design-main-title"},[_c('div',{staticClass:"design-main-title-title"},[_c('span',[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.title))]})],2)]),(_vm.idField)?_c('import-export',_vm._g(_vm._b({attrs:{"id-field":_vm.idField}},'import-export',_vm.$attrs,false),_vm.$listeners)):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }